import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import MetabaseDashboardUrl from "../model/MetabaseDashboardUrl";

export const GetMetabaseUrlApiService = async (
  employerIds: string | number
): Promise<MetabaseDashboardUrl> => {
  const url = `/metabase/dashboard/?employer_ids=${employerIds}`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useGetMetabaseUrlApiService = (employerIds: string | number) =>
  useQuery<Promise<MetabaseDashboardUrl>, AxiosError, MetabaseDashboardUrl>(
    ["GetMetabaseUrlApiService", employerIds],
    () => GetMetabaseUrlApiService(employerIds)
  );

export default useGetMetabaseUrlApiService;
